import { render, staticRenderFns } from "./InitialForm_42.vue?vue&type=template&id=41086921&scoped=true"
import script from "./InitialForm_42.ts?vue&type=script&lang=ts&external"
export * from "./InitialForm_42.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41086921",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41086921')) {
      api.createRecord('41086921', component.options)
    } else {
      api.reload('41086921', component.options)
    }
    module.hot.accept("./InitialForm_42.vue?vue&type=template&id=41086921&scoped=true", function () {
      api.rerender('41086921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P42/InitialForm_42/InitialForm_42.vue"
export default component.exports